export const LoadBenefitPageTypes = {
  Default: 'default',
  Lounari: 'lounari',
  Others: 'others'
} as const;

type LoadBenefitPageTypesKeys = keyof typeof LoadBenefitPageTypes;

export type LoadBenefitPageType =
  (typeof LoadBenefitPageTypes)[LoadBenefitPageTypesKeys];
